import { Container } from '@mui/joy';
import Typography from '@mui/joy/Typography';
import { useEffect } from 'react';
import { useFeedback } from './components/feedback/Service';
import { useNavigate } from 'react-router';

const Home = () => {
  const feedback = useFeedback();
  const navigate = useNavigate();

  useEffect(() => {
    feedback.snackbar({ text: "Welcome to Cavalry", type: "warning" });
    navigate("/sign-up");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container
      maxWidth="sm"
      sx={{
        p: 2
      }}
    >
      <Typography level="h1" color="primary" gutterBottom>Hello</Typography>
    </Container>
  );
}

export default Home;